import { CdkTableModule } from '@angular/cdk/table';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { SafeHtml } from '../core/pipes/safeHtml-pipe';
// tslint:disable-next-line:max-line-length
import { MatAutocompleteModule, MatButtonModule, MatButtonToggleModule, MatCardModule, MatCheckboxModule, MatChipsModule, MatDatepickerModule, MatDialogModule, MatDividerModule, MatExpansionModule, MatGridListModule, MatIconModule, MatInputModule, MatListModule, MatMenuModule, MatNativeDateModule, MatPaginatorModule, MatProgressBarModule, MatProgressSpinnerModule, MatRadioModule, MatRippleModule, MatSelectModule, MatSidenavModule, MatSlideToggleModule, MatSliderModule, MatSnackBarModule, MatSortModule, MatStepperModule, MatTableModule, MatTabsModule, MatToolbarModule, MatTooltipModule } from '@angular/material';
import { RouterModule } from '@angular/router';
import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { BaseService } from '../core/services/base.service';
import { HttpService } from '../core/services/http.service';
import { ShoppingService } from '../core/services/shopping.service';
import { FooterComponent } from '../layout/footer/footer.component';
import { HeaderComponent } from '../layout/header/header.component';
import { AddressComponent } from './address/address.component';
import { CartItemsComponent } from './cart-items/cart-items.component';
import { CartComponent } from './cart/cart.component';
import { CheckoutComponent } from './checkout/checkout.component';
import { CreateAccountComponent } from './create-account/create-account.component';
import { FaqComponent } from './faq/faq.component';
import { ItemListDialogComponent } from './item-list-dialog/item-list-dialog.component';
import { ReconcileItemListDialogComponent } from './reconcile-item-list-dialog/reconcile-item-list-dialog.component';
import { LoginComponent } from './login/login.component';
import { OrderSummaryComponent } from './order-summary/order-summary.component';
import { PaymentComponent } from './payment/payment.component';
import { PromoCodeComponent } from './promo-code/promo-code.component';
import { ShoppingcartComponent } from './shoppingcart.component';
// Routes
import { ShoppingCartRoutes as routes } from './shoppingcart.route';
import { HelperService } from '../core/services/helper.service';
import { CustomErrorHandlerService } from '../core/services/custom-error-handler.service';
import { LoadingModule, ANIMATION_TYPES } from 'ngx-loading';
import { PromptComponent } from '../layout/prompt/prompt.component';
import { AlertComponent } from '../layout/prompt/alert.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AddItemUsingEmailComponent } from './add-item-using-email/add-item-using-email.component';
import { OrderCompleteComponent } from './order-complete/order-complete.component';
import { PhysicalWebOrderComponent } from './physical-web-order/physical-web-order.component';
import { OrderDetailComponent } from './order-detail/order-detail.component';
import { AutoLogOutDialogComponent } from './auto-log-out-dialog/auto-log-out-dialog.component';
import { UspsDialogComponent } from './usps-dialog/usps-dialog.component';
import { FooterService } from '../core/services/footer.services';
import { RestrictMaliciousInputDirective } from '../core/directives/restrictMaliciousInput.directive';
import { BraintreeDropinComponent } from './braintree-dropin/braintree-dropin.component';
import { BraintreePayDirective } from '../core/directives/braintree-pay.directive';
import { BraintreeDropinDirective } from '../core/directives/braintree-dropin.directive';
import { BraintreeDropinService } from '../core/services/braintree-dropin.service';
import { ConfirmDialogService } from '../core/services/confirm-dialog.service';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { InstructorNotConfirmedComponent } from './modals/instructor-not-confirmed/instructor-not-confirmed.component';
import { InstructorResendConfirmationComponent } from './modals/instructor-resend-confirmation/instructor-resend-confirmation.component';
import { EmailAlreadyExistPopupComponent } from './modals/email-already-exist-popup/email-already-exist-popup.component';

// import { DefaultUrlSerializer, UrlSerializer, UrlTree } from '@angular/router';

// export class TitleCaseUrlSerializer extends DefaultUrlSerializer {
//   public parse(url: string): UrlTree {
//       function toTitleCase(url) {
//           return url.split('/')
//                      .map(segment => segment ?
//                                      segment[0].toUpperCase() + segment.substr(1) :
//                                      segment)
//                      .join('/');
//       }
//       return super.parse(toTitleCase(url));
//   }
// }


@NgModule({
  declarations: [
    ShoppingcartComponent,
    CheckoutComponent,
    CartComponent,
    HeaderComponent,
    FooterComponent,
    OrderSummaryComponent,
    LoginComponent,
    AddressComponent,
    PaymentComponent,
    CreateAccountComponent,
    PromoCodeComponent,
    CartItemsComponent,
    FaqComponent,
    ItemListDialogComponent,
    ReconcileItemListDialogComponent,
    PromptComponent,
    AlertComponent,
    AddItemUsingEmailComponent,
    OrderCompleteComponent,
    PhysicalWebOrderComponent,
    OrderDetailComponent,
    AutoLogOutDialogComponent,
    UspsDialogComponent,
    ConfirmDialogComponent,
    SafeHtml,
    RestrictMaliciousInputDirective,
    BraintreeDropinDirective,
    BraintreePayDirective,
    BraintreeDropinComponent,
    InstructorNotConfirmedComponent,
    InstructorResendConfirmationComponent,
    EmailAlreadyExistPopupComponent

  ],
  exports: [
    CdkTableModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatStepperModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    SafeHtml,
  ],
  imports: [
    HttpModule,
    RouterModule.forChild(routes),
    AngularFontAwesomeModule,
    CommonModule,
    MatNativeDateModule,
    ReactiveFormsModule,
    LoadingModule.forRoot({
      animationType: ANIMATION_TYPES.threeBounce,
      backdropBackgroundColour: 'rgba(0,0,0,0.1)',
      backdropBorderRadius: '4px',
      primaryColour: '#277F5C',
      secondaryColour: '#ffffff',
      tertiaryColour: '#277F5C',
      fullScreenBackdrop: true
    }),
    NgbModule
  ],
  entryComponents: [ShoppingcartComponent, ItemListDialogComponent, ReconcileItemListDialogComponent, ConfirmDialogComponent,
    PromptComponent,AlertComponent, PhysicalWebOrderComponent, AutoLogOutDialogComponent, UspsDialogComponent, InstructorNotConfirmedComponent, InstructorResendConfirmationComponent,EmailAlreadyExistPopupComponent],
  providers: [
    HttpService, HelperService, CustomErrorHandlerService, BaseService, ShoppingService, FooterService, BraintreeDropinService, ConfirmDialogService
    //   {
    //     provide: UrlSerializer,
    //     useClass: TitleCaseUrlSerializer
    // }
  ]
})
export class ShoppingCartModule { }



// WEBPACK FOOTER //
// ./src/app/shoppingcart/index.ts